import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { actionCreators } from '../actions/globalAction';
import { Pagination } from '../components/Pagination';
import { Loader } from '../components/solar/Loader';
import { abschlag } from '../components/objects/abschlag';

class AbschlagClass extends Component {

    // einmaliges wie PageLoad wird nur inital aufgerufen
    componentDidMount() {
        let Year = parseInt(this.props.match.params.Year) || new Date().getFullYear();
        
        abschlag.AbschlagClass.url = abschlag.AbschlagClass.defaultSegment + "/abschlag/" + Year;
        this.props.request(abschlag["AbschlagClass"]);
    }

    // komisches construct???
    //static getDerivedStateFromProps(props, state) {
    //    debugger;
    //    return null;
    //}

    // bei jeder änderung wird dieses aufgerufen
    shouldComponentUpdate(nextProps, nextState) {
        let nextYear = parseInt(nextProps.match.params.Year) || 0;
        let Year = parseInt(this.props.match.params.Year) || 0;

        // Aktualisieren wenn: Daten werden geladen ODER Jahr hat sich geaendert
        let result = !this.props.isLoaded || nextYear !== Year;

        if (nextYear !== Year) {
            abschlag.AbschlagClass.forceRefresh = true;
            abschlag.AbschlagClass.url = abschlag.AbschlagClass.defaultSegment + "/abschlag/" + nextYear;
            this.props.request(abschlag["AbschlagClass"]);
        }

        return result;
    }

    // Legacy sollte nicht mehr benutzt werden
    //componentWillReceiveProps(nextProps) {
    //}

    render() {
        let AbschlagUI = this.props.AbschlagUI || {};
        
        return (
            <div className="table-responsive">
                <Loader show={!this.props.isLoaded} />
                <div dangerouslySetInnerHTML={{ __html: AbschlagUI }} />
                <Pagination routeSegment={'abschlag'} onlyYear={true} prop={this.props} />
            </div>
        );
    }

    // Nach dem rendern
    componentDidUpdate(prevProps, prevState, snapshot) {
    }

}

export default connect(
    state => state.abschlagReducer,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(AbschlagClass);